export default () => ({
  workspaces: [],
  workspacesCount: 0,
})
